module.exports = __webpack_public_path__ + "3a92e3c4f5721c8e504f9fad503aefe8.png";